import React from "react";
import styled from "styled-components";
import Comment from "./Comment";
import syntalix from '../img/IMG_20231218_101705.png';

const Container = styled.div`
  background-color: rgba(52, 49, 49, 0.551);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(5px);
  border-radius: 25px;
  padding: 20px;
`;

const NewComment = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Avatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
`;

const Input = styled.input`
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.soft};
  color: ${({ theme }) => theme.text};
  background-color: transparent;
  outline: none;
  padding: 5px;
  width: 100%;

  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;

const Comments = () => {
  return (
    <Container>
      <NewComment>
        <Avatar src={syntalix} style={{ backgroundColor: " black" }} />
        <Input placeholder="Add a comment..." />
      </NewComment>
      <Comment />
      <Comment />
      <Comment />
      <Comment />
      <Comment />
      <Comment />
      <Comment />
    </Container>
  );
};

export default Comments;
